import { useValueStore } from '@/stores/composables/useValueStore';
import { acceptHMRUpdate, defineStore } from 'pinia';
import type { CustomerDocumentVersion } from './types/customer-document-version';

export const useCustomerDocumentVersionStore = defineStore('useCustomerDocumentVersion', () => ({
  ...useValueStore<CustomerDocumentVersion>('document-version'),
}));

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCustomerDocumentVersionStore, import.meta.hot));
}
